import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-special-wager-races',
  templateUrl: './special-wager-races.component.html',
  styleUrls: ['./special-wager-races.component.scss']
})
export class SpecialWagerRacesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
